import Main from '@/views/administracion/configuracion/catalogos/funcionarios/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/funcionarios/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const funcionarios = [
  {
    path: 'responsables',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoFuncionarios',
        path: '/',
        meta: {
          title: 'Responsables',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default funcionarios;
